
import Vue from 'vue'
import JImageGallery from '@/ui/controls/JImageGallery.vue'
import Image from '@/models/Image'
import { sortDateDesc } from '@/helpers/sorters'

export default Vue.extend({
  components: {
    JImageGallery,
  },
  props: {
    imageId: String,
  },
  data: () => ({
    rows: 4,

    cols: 6,
    sm: 4,
    md: 3,
    lg: 3,
    xl: 2,
  }),
  computed: {
    images(): Array<Image> {
      return this.allImages.slice(0, this.imageCount)
    },
    allImages(): Array<Image> {
      return this.$store.getters['gardens/images/all']
        .slice()
        .sort(sortDateDesc<Image>('takenAt', sortDateDesc<Image>('createdAt')))
    },
    imageCount(): number {
      return this.imagesPerRow * this.rows
    },
    imagesPerRow(): number {
      return Math.floor(12 / this.currentCols)
    },
    hasImages(): boolean {
      return this.allImages.length > 0
    },
    hasMoreImages(): boolean {
      return this.imageCount < this.allImages.length
    },
    currentCols(): number {
      switch (this.$vuetify.breakpoint.name) {
        case 'xl':
          return this.xl || this.lg || this.md || this.sm || this.cols || 12
        case 'lg':
          return this.lg || this.md || this.sm || this.cols || 12
        case 'md':
          return this.md || this.sm || this.cols || 12
        case 'sm':
          return this.sm || this.cols || 12
        default:
          return this.cols || 12
      }
    },
  },
  methods: {
    moreRows(numOfRows = 4) {
      this.rows += numOfRows
    },
  },
})
